/*
 * @Author: LiuChuanQi
 * @Date: 2022-10-31 11:59:03
 * @LastEditTime: 2022-11-16 16:00:12
 * @LastEditors: LiuChuanQi
 * @Description: 运营商全局状态管理
 * @FilePath: \speedtest-bigdata-v2\src\store\modules\loadding.js
 * 
 */
const loadding = {
  state: {
    OperatorData: new Array(12).fill(false), // 运营商数据所有组件加载状态
    RankingData: new Array(12).fill(false), //  排行榜所有组件加载状态
    Home: new Array(9).fill(false), //  实时数据所有组件加载状态
    hotMap: [false], //  热力图加载状态 首屏加载缓慢
    speedMap: [false], //  网速地图加载动画
    //运营商二级页面状态管理
    operatorSpeed: new Array(4).fill(false),
    operatorMonthScore: [false],
    OperatorNetworkQualityComparison: new Array(6).fill(false), //运营商网络质量对比
    OperatorUserSpeed: [false, false], //运营商用户网速排行
    OperatorMarket: [false, false, false, false], //运营商市场占有率
    OperatorSatisfactionRanking: [false, false, false, false], //运营商满意度排行
    OperatorSpeedDistribution: [false, false], //运营商网速分布
    OperatorSpecialSpeed: [false, false], //运营商专项体验测速
    OperatorProvinceSpeed: [false, false], //各省网速排行
    //排行榜二级页面状态管理
    RanksPhoneBrandSpeed: [false, false], //5g手机品牌网速中值排行
    RanksPhoneBrandRecommendation: [false],//5G手机品牌推荐排行
    RanksRouterHighOpinion: [false],//5G手机品牌推荐排行
    RanksRouterMarket: [false, false], //路由器市场占用率
    RanksPhoneMarket: [false, false], //手机市场占用率
    RanksPlatformNetworkDelay: [false],//主流平台时延排行
    RanksWebsitesEntrySpeed: [false, false, false, false],//主流网站打开速度
    RanksVideoBuffer: [false, false],//视频缓冲比
    RanksProvinceNetworkQuality: [false, false, false],//各省网络质量排行
    RanksVideoLoadding: [false, false], //各省视频平均加载时间
    RanksVideoResolutionRatio: [false, false], //各省视频平均加载时间
    //实时数据二级页面
    RealTimeNetworkDistribution: [false, false],//实时数据网速分布图
    RealTimeUserSpeed: [false, false],//实时数据用户网速排行
    RealTimeMonthScore: [false],//实时数据近三十的网速趋势
    RealTimeNetworkQualityComparison: new Array(6).fill(false), //实时数据网络质量对比
    RealTimeSpecialExperienceTest: [false, false],//实时数据专项体验测试
    RealTimeNetworkSpeedRatio: [false, false, false, false], //实时数据网速占比
    RealTimeProvinceSpeed:[false,false], //实时数据各省网速
  },
  mutations: {

  },
  actions: {

  }
}

export default loadding